import { Card, CardContent, CardHeader } from '@mui/material';

import {
  IPaginationProps,
  LinearProgress,
  LoadedContent,
  Pagination,
  Table,
  TableContainer,
  TableHeader,
  Typography,
} from '@occc-app/design-system';
import { SurveyLocationStatisticsFragment } from '@occc/graphql';
import { LoadedData } from '@occc-app/routes/Wallet/types';

import { SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from './types';
import { SurveyLocationsTableHead } from './SurveyLocationsTableHead';
import { SurveyLocationsTableBody } from './SurveyLocationsTableBody';

import { renderEmptyState } from '../../../design-system/components/LoadedContent/utils';
import { SortingProps } from '../../../hooks/useSortingParams';

export type SurveyLocationsProps = {
  locationStatisticsData: LoadedData<SurveyLocationStatisticsFragment[]>;
  responseStatisticsPerLocationMap: Record<
    string,
    SurveyStatisticsPieChartItem | SurveyStatisticsBarChartItem
  >;
  paginationProps: IPaginationProps;
  sortingProps?: SortingProps;
};

export const SurveyLocations = ({
  locationStatisticsData,
  responseStatisticsPerLocationMap,
  paginationProps,
  sortingProps,
}: SurveyLocationsProps) => {
  const { loading, error, data } = locationStatisticsData;

  const renderData = () => {
    return (
      <TableContainer>
        <TableHeader title='All Locations' />

        {loading && <LinearProgress />}

        <Table>
          <SurveyLocationsTableHead sortingProps={sortingProps} />

          <SurveyLocationsTableBody
            data={data}
            responseStatisticsPerLocationMap={responseStatisticsPerLocationMap}
          />
        </Table>

        <Pagination {...paginationProps} />
      </TableContainer>
    );
  };

  const renderEmpty = () => {
    return (
      <Card>
        <CardHeader title={<Typography variant='subtitle1'>All Locations</Typography>} />
        <CardContent>{renderEmptyState()}</CardContent>
      </Card>
    );
  };

  return (
    <LoadedContent<SurveyLocationStatisticsFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
      renderEmpty={renderEmpty}
    />
  );
};
